export const WAREHOUSE_TAB_DATA = 'data';
export const WAREHOUSE_TAB_ADMINS = 'admins';
export const WAREHOUSE_TAB_PH = 'ph';
